"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.orderCancels = void 0;
var utils_1 = require("../../utils");
exports.orderCancels = function (axios) {
    return {
        // 주문취소 신청
        postOrderCancels: function (request) {
            return axios.post('/order-cancels', request.data);
        },
        /** @deprecated postOrderCancelsPredictV2 사용해주세요 */
        postOrderCancelsPredict: function (request) {
            return axios.post('/order-cancels/predict', request.data);
        },
        // 주문취소 예상금액을 계산
        postOrderCancelsPredictV2: function (request) {
            return axios.post('/order-cancels/predict', request.data);
        },
        // 미입금 다건 주문취소 신청
        postOrderCancelsBeforePay: function (request) {
            return axios.post('/order-cancels/before-pay', request.data);
        },
        // 주문취소 수정
        putOrderCancelsNo: function (request) {
            var url = utils_1.paramPathchange('/order-cancels/{no}', request);
            return axios.put(url, request.data);
        },
        // 주문취소 승인
        putOrderCancelsNoApprove: function (request) {
            var url = utils_1.paramPathchange('/order-cancels/{no}/approve', request);
            return axios.put(url);
        },
        // 주문취소 현금으로 환불처리
        putOrderCancelsNoRefundCash: function (request) {
            var url = utils_1.paramPathchange('/order-cancels/{no}/cash-refund', request);
            var config = {
                headers: __assign({}, request.headers)
            };
            return axios.put(url, request.data, config);
        },
        putOrderCancelsNoWithdraw: function (request) {
            var url = utils_1.paramPathchange('/order-cancels/{no}/withdraw', request);
            return axios.put(url, request.data);
        }
    };
};
